export default "__VITE_ASSET__BxDntaCE__"